// eslint-disable-next-line
import util from 'util';

// eslint-disable-next-line
import * as actionTypes from '../actionTypes';

const initialState = {
  accountId: '',
  account: {},
  accountLoading: false,
  calleridRequest: {},
  invoice: {},
  invoiceOpen: false,
  paymentMethods: {},
  storedPaymentOpen: false,
  submittingPayment: false,
  autopayEnrollOpen: false,
  submittingAutopayEnroll: false,
  callSummaryStats: {},
  callVolumes:{
    id:1
  },
  contactInsights:{
    id:1,
  },
  tasksByInvoice:[],
  invoiceId:'-1',
  selInvoice:{},
  chats:[],
  paymentMethod: {},
  addPaymentMethodOpen: false,
  addingPaymentMethod: false,
  updatePaymentMethodOpen: false,
  updatePaymentMethod: {},
  savingPaymentMethod: false,
  plaidLinkToken: null,
  plaidAuthResponse: {},
  addBankAccountOpen: false,
  addingBankAccount: false,
  queryingSurcharge: false,
  surchargeQueried: false,
  showPaymentConfirmation: false,
  okToSubmitPayment: false,
  surchargeObject : {},
  setPhoneNumberInsights: {},
  billingEmails: { destinations: [] },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_ACCOUNT_ID: {
      return ({ ...state, accountId: action.payload.accountId });
    }
    case actionTypes.SET_ACCOUNT: {
      return ({ ...state, account: action.payload.account });
    }
    case actionTypes.SET_ACCOUNT_LOADING: {
      return ({ ...state, accountLoading: action.payload.accountLoading });
    }
    case actionTypes.SET_CALLERID_REQUEST: {
      return ({ ...state, calleridRequest: action.payload.calleridRequest });
    }
    case actionTypes.SET_INVOICE: {
      return ({ ...state, invoice: action.payload.invoice });
    }
    case actionTypes.SET_INVOICE_OPEN: {
      return ({ ...state, invoiceOpen: action.payload.invoiceOpen });
    }
    case actionTypes.SET_PAYMENT_METHODS: {
      return ({ ...state, paymentMethods: action.payload.paymentMethods });
    }
    case actionTypes.SET_STORED_PAYMENT_OPEN: {
      return ({ ...state, storedPaymentOpen: action.payload.storedPaymentOpen });
    }
    case actionTypes.SET_SUBMITTING_PAYMENT: {
      return ({ ...state, submittingPayment: action.payload.submittingPayment });
    }
    case actionTypes.SET_AUTOPAY_ENROLL_OPEN: {
      return ({ ...state, autopayEnrollOpen: action.payload.autopayEnrollOpen });
    }
    case actionTypes.SET_SUBMITTING_AUTOPAY_ENROLL: {
      return ({ ...state, submittingAutopayEnroll: action.payload.submittingAutopayEnroll });
    }
    case actionTypes.SET_CALL_SUMMARY_STATS: {
      return ({ ...state, callSummaryStats: action.payload.callSummaryStats });
    }
    case actionTypes.SET_CALL_VOLUMES_BAR_GRAPH: {
      //const { callVolumes } = state;
      return ({ ...state, callVolumes: action.payload.callVolumesBarGraphData });
      //return ({ ...state, callVolumes: { ...callVolumes, options: { ...callVolumes.options, xaxis: { ...callVolumes.options.xaxis, categories: action.payload.callVolumesBarGraphData.categories } }, series: action.payload.callVolumesBarGraphData.series } });
    }
    case actionTypes.SET_CONTACT_INSIGHTS_BAR_GRAPH: {
      return ({ ...state, contactInsights: action.payload.contactInsightsBarData });
      //const { contactInsights } = state;
      //return ({ ...state, contactInsights: { ...contactInsights, options: { ...contactInsights.options, xaxis: { ...contactInsights.options.xaxis, type:'category',convertedCatToNumeric:true,labels:{tickPlacement:'on'},categories: action.payload.contactInsightsBarData.categories } }, series: action.payload.contactInsightsBarData.series } });
    }
    case actionTypes.SET_TASK_BY_INVOICE: {
      return ({ ...state, tasksByInvoice: action.payload.tasksByInvoice });
    }
    case actionTypes.SET_INVOICE_ID: {
      let selInvoice = {};
      if(state.account && state.account.invoices){
        state.account.invoices.forEach(element => {
            if(element.invoiceId===action.payload.invoiceId){
              selInvoice = element;
            }
        });
     }
      return ({ ...state, invoiceId: action.payload.invoiceId,selInvoice });
    }
    case actionTypes.SET_WEB_LEADS: {
      return ({ ...state, chats: action.payload.chats });
    }
    case actionTypes.SET_PAYMENT_METHOD : {
      return({...state, paymentMethod: action.payload.paymentMethod });
    }
    case actionTypes.SET_ADD_PAYMENT_METHOD_OPEN : {
      return({...state, addPaymentMethodOpen: action.payload.addPaymentMethodOpen });
    }
    case actionTypes.SET_ADDING_PAYMENT_METHOD : {
      return({...state, addingPaymentMethod: action.payload.addingPaymentMethod });
    }
    case actionTypes.SET_UPDATE_PAYMENT_METHOD_OPEN : {
      return({...state, updatePaymentMethodOpen: action.payload.updatePaymentMethodOpen });
    }
    case actionTypes.SET_UPDATE_PAYMENT_METHOD : {
      return({...state, updatePaymentMethod: action.payload.updatePaymentMethod });
    }
    case actionTypes.SET_SAVING_PAYMENT_METHOD : {
      return({...state, savingPaymentMethod: action.payload.savingPaymentMethod });
    }
    case actionTypes.SET_PLAID_LINK_TOKEN : {
      return({...state, plaidLinkToken: action.payload.plaidLinkToken });
    }
    case actionTypes.SET_PLAID_AUTH_RESPONSE : {
      return({...state, plaidAuthResponse: action.payload.plaidAuthResponse });
    }
    case actionTypes.SET_ADD_BANK_ACCOUNT_OPEN : {
      return({...state, addBankAccountOpen: action.payload.addBankAccountOpen });
    }
    case actionTypes.SET_ADDING_BANK_ACCOUNT : {
      return({...state, addingBankAccount: action.payload.addingBankAccount });
    }
    case actionTypes.SET_QUERYING_SURCHARGE : {
      return({...state, queryingSurcharge: action.payload.queryingSurcharge });
    }
    case actionTypes.SET_SURCHARGE_QUERIED : {
      return({...state, surchargeQueried: action.payload.surchargeQueried });
    }
    case actionTypes.SET_SHOW_PAYMENT_CONFIRMATION : {
      return({...state, showPaymentConfirmation: action.payload.showPaymentConfirmation });
    }
    case actionTypes.SET_OK_TO_SUBMIT_PAYMENT : {
      return({...state, okToSubmitPayment: action.payload.okToSubmitPayment });
    }
    case actionTypes.SET_SURCHARGE_OBJECT : {
      return({...state, surchargeObject: action.payload.surchargeObject });
    }
    case actionTypes.SET_PHONE_NUMBER_INSIGHTS : {
      return({...state, phoneNumberInsights: action.payload.phoneNumberInsights });
    }
    case actionTypes.SET_BILLING_EMAILS : {
      // Ensure we always have a valid structure with destinations array
      const billingEmails = action.payload.billingEmails || { destinations: [] };
      const normalized = {
        ...billingEmails,
        destinations: Array.isArray(billingEmails.destinations) ? billingEmails.destinations : []
      };
      return({...state, billingEmails: normalized });
    }
    default: {
      return (state);
    }
  }
}
